import { useState, useEffect } from 'react';
import {
  formatNumberToCurrencyString,
  parseInputToDouble,
} from '../utils/currencyInputHelpers';

export const useCurrencyInput = ({ value, onChange, name }) => {
  const [displayValue, setDisplayValue] = useState(
    formatNumberToCurrencyString(value)
  );

  useEffect(() => {
    setDisplayValue(formatNumberToCurrencyString(value));
  }, [value]);

  const handleChange = (e) => {
    const rawInput = e.target.value;
    const digits = rawInput.replace(/\D/g, '');

    if (!digits) {
      setDisplayValue('');
      if (onChange) {
        onChange({ target: { name, value: 0 } }, 0);
      }
      return;
    }

    const doubleValue = parseInputToDouble(rawInput);
    setDisplayValue(formatNumberToCurrencyString(doubleValue));

    if (onChange) {
      onChange({ target: { name, value: doubleValue } }, doubleValue);
    }
  };

  return {
    displayValue,
    handleChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyInput/hooks/useCurrencyInput.js